"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var react_1 = __importDefault(require("react"));
var UserSettingsForm_module_css_1 = __importDefault(require("./UserSettingsForm.module.css"));
function UserSettingsFormItem(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var text = props.text, labelText = props.labelText, id = props.id, type = props.type, value = props.value, className = props.className, required = props.required, disabled = props.disabled, _b = props.error, error = _b === void 0 ? "" : _b, dataCy = props.dataCy, onChange = props.onChange;
    return (react_1.default.createElement("div", { id: UserSettingsForm_module_css_1.default.inputContainer },
        react_1.default.createElement(Label_1.default, { htmlFor: id, className: UserSettingsForm_module_css_1.default.label }, text),
        react_1.default.createElement(Label_1.default, { htmlFor: id, className: UserSettingsForm_module_css_1.default.labelText }, labelText),
        react_1.default.createElement("div", { className: UserSettingsForm_module_css_1.default.inputFieldContainer },
            react_1.default.createElement("div", { className: "w-100" },
                react_1.default.createElement("input", { id: id, type: type, className: className, value: value, onChange: onChange, required: required, disabled: disabled, "data-cy": dataCy }),
                error.length > 0 && (react_1.default.createElement("span", { className: "invalid-feedback" }, error)),
                children))));
}
exports.default = UserSettingsFormItem;
